import React from 'react';
import SkeletonBox from './SkeletonBox';
import './FlightListSkeleton.css';

const FlightListSkeleton = () => (
  <div className="flightListSkeleton">
    <div className="flightListSkeleton__searchBar">
      <SkeletonBox width="100%" height="90px" radius="20px" />
    </div>

    <div className="flightListSkeleton__body">
      <div className="flightListSkeleton__sidebar">
        <SkeletonBox width="80px" height="18px" />
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flightListSkeleton__filterGroup">
            <SkeletonBox width="120px" height="14px" />
            <SkeletonBox width="100%" height="36px" radius="10px" />
          </div>
        ))}
      </div>

      <div className="flightListSkeleton__main">
        <div className="flightListSkeleton__dateTabs">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBox key={i} width="100%" height="52px" radius="10px" />
          ))}
        </div>

        <div className="flightListSkeleton__sortTabs">
          <SkeletonBox width="110px" height="40px" radius="10px" />
          <SkeletonBox width="110px" height="40px" radius="10px" />
          <SkeletonBox width="110px" height="40px" radius="10px" />
        </div>

        <div className="flightListSkeleton__cards">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flightListSkeleton__card">
              <SkeletonBox width="40px" height="40px" radius="8px" />
              <SkeletonBox width="80px" height="16px" />
              <SkeletonBox width="60px" height="20px" />
              <SkeletonBox width="90px" height="14px" />
              <SkeletonBox width="60px" height="20px" />
              <SkeletonBox width="80px" height="24px" />
              <SkeletonBox width="90px" height="38px" radius="42px" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default FlightListSkeleton;
